import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import 'datatables.net-bs5';
import $ from 'jquery';
import CreateCustomerModal from "../../../Customer/View/CreateCustomer";
import CustomerService from "../../../Customer/Controller/CustomerController";
import Draggable from 'react-draggable';

function CustomerSelectionModal({ show, onClose, onSelectCustomer }) {
    const tableRef = useRef();
    const [customers, setCustomers] = useState([]);

    const [modalInstanceCustomerDetail, setModalInstanceCustomerDetail] = useState(null);
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    // Function to fetch the customer list from the server
    const fetchCustomers = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            $(tableRef.current).DataTable().destroy();
            const listOfCustomers = await CustomerService.GetAllCustomers(redirectCallback);
            setCustomers(listOfCustomers);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };

    // Function to initialize or reinitialize DataTable
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy(); // Destroy existing DataTable to refresh it
        }

        $(tableRef.current).DataTable({
            dom: '<"row"<"col-sm-6 d-flex align-items-center"Bf><"col-sm-6 d-flex justify-content-end"p>>rt',
            pagingType: 'full_numbers',
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search..."
            },
            lengthChange: false,
            initComplete: function () {
                console.log('DataTable re-initialization complete.');
            }
        });

        // Move the search input if needed
        $('#datatable-search-container').append($('.dataTables_filter').html());
        $('.dataTables_filter').remove();
    };

    // Fetch customers when modal is shown
    useEffect(() => {
        if (show) {
            fetchCustomers();
        }
    }, [show]);

    // Re-initialize DataTable whenever customers change
    useEffect(() => {
        if (customers.length > 0) {
            initDataTable(); // Re-initialize DataTable when customers are fetched
        }
    }, [customers]);

    // Handle the creation of a new customer (open modal)
    const handleCreateCustomerClick = () => {
        $(tableRef.current).DataTable().destroy();
        setIsModalOpen(true);
    };

    // Handle modal close and refresh customer list
    const handleCloseModal = async () => {
        $(tableRef.current).DataTable().destroy();
        await fetchCustomers();
        setIsModalOpen(false);
    };

    // Prevent dragging issues in modal
    const handleStart = (e, ui) => {
        e.stopPropagation();
    };

    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <Draggable handle=".modal-content" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Select Customer</h5>
                            <span>
                                <button type="button" className="btn-close" style={{ "marginLeft": "5px" }} onClick={onClose} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </span>
                        </div>
                        <div className="modal-body" style={{ "maxHeight": "400px", "overflow": "auto" }}>
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="card mb-30">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <button className='btn btn-primary btn-sm' onClick={handleCreateCustomerClick} style={{ "fontSize": "0.7vw" }}>
                                                    <i className="icofont-plus" aria-hidden="true"> Add New</i>
                                                </button>
                                                <table className="table m-0 table-hover" ref={tableRef} style={{ "width": "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th className="no-wrap" data-sortable>Customer</th>
                                                            <th className="no-wrap" data-sortable>Town/City</th>
                                                            <th className="no-wrap" data-sortable>Post Code</th>
                                                            <th className="no-wrap" data-sortable>Telephone</th>
                                                            <th className="no-wrap" data-sortable>Customer Type</th>
                                                            <th className="no-wrap" data-sortable>Account Status</th>
                                                            <th className="no-wrap" data-sortable>Account Ref</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {customers.map(customer => (
                                                            <tr key={customer.ClientCompanyID} onClick={() => onSelectCustomer(customer)} style={{ cursor: 'pointer' }}>
                                                                <td className="no-wrap">

                                                                    {customer.CompanyName && customer.CompanyName.length > 20
                                                                        ? `${customer.CompanyName.substring(0, 20)}...`
                                                                        : customer.CompanyName}
                                                                </td>
                                                                <td className="no-wrap">{customer.City}</td>
                                                                <td className="no-wrap">{customer.Postcode}</td>
                                                                <td className="no-wrap">{customer.Phone1}</td>
                                                                <td className="no-wrap">{customer.FK_ClientCompanyType_ID}</td>
                                                                <td className="no-wrap">{customer.vc_AccountStatus}</td>
                                                                <td className="no-wrap">{customer.AccountRef}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {isModalOpen && (
                            <CreateCustomerModal
                                ClientCompanyID="0"
                                onClose={handleCloseModal}
                                onSuccess={fetchCustomers} // Refresh customers on success
                                IsCustomerSelection="1"
                            />
                        )}
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default CustomerSelectionModal;
